export default "__VITE_ASSET__832f1a51__"